module.exports = __webpack_public_path__ + "static/orderNo-1463bc535066aeb736eede23731f65bb.png";